import { render, staticRenderFns } from "./MoreGamesPage.vue?vue&type=template&id=34a3ff1c&"
import script from "./MoreGamesPage.vue?vue&type=script&lang=js&"
export * from "./MoreGamesPage.vue?vue&type=script&lang=js&"
import style0 from "./MoreGamesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports